module.exports = __webpack_public_path__ + "img/dog-office.fd06cdde.jpg";